export const navigation = [
 
   {
    name: 'Root',
    url: '/admin/projects/list',
    icon: 'laso-tree',

  },
  {
    name: 'Branches',
    url: '/admin/branches/list',
    icon: 'icon-vector',
//    children: [
//      {
//        name: 'Font Awesome',
//        url: '/icons/font-awesome',
//        icon: 'icon-star',
//        badge: {
//          variant: 'secondary',
//          text: '4.7'
//        }
//      },
//      {
//        name: 'Simple Line Icons',
//        url: '/icons/simple-line-icons',
//        icon: 'icon-star'
//      }
//    ]
  },
  {
    name: 'Response',
    url: '/admin/responses',
    icon: 'icon-book-open',
//    badge: {
//      variant: 'info',
//      text: 'NEW'
//    }
  },
  {
    name: 'User Management',
    url: '/admin/users/list',
    icon: 'icon-people'
  },
  {
    name: 'Legal Issues',
    url: '/admin/issuecodes/list',
    icon: 'icon-film'
  },
  {
    name: 'Organizations',
    url: '/admin/organizations',
    icon: 'icon-layers'
  },
  {
    name: 'Resources',
    url: '/admin/resources',
    icon: 'icon-link'
  },
//  {
//    divider: true
//  },
//  {
//    title: true,
//    name: 'Extras',
//  },
//  {
//    name: 'Pages',
//    url: '/pages',
//    icon: 'icon-star',
//    children: [
//      {
//        name: 'Login',
//        url: '/pages/login',
//        icon: 'icon-star'
//      },
//      {
//        name: 'Register',
//        url: '/pages/register',
//        icon: 'icon-star'
//      },
//      {
//        name: 'Error 404',
//        url: '/pages/404',
//        icon: 'icon-star'
//      },
//      {
//        name: 'Error 500',
//        url: '/pages/500',
//        icon: 'icon-star'
//      }
//    ]
//  },
//  {
//    name: 'Download CoreUI',
//    url: 'http://coreui.io/angular/',
//    icon: 'icon-cloud-download',
//    class: 'mt-auto',
//    variant: 'success'
//  },
//  {
//    name: 'Try CoreUI PRO',
//    url: 'http://coreui.io/pro/angular/',
//    icon: 'icon-layers',
//    variant: 'danger'
//  }
];



// WEBPACK FOOTER //
// /var/www/html/LASO/laso-client/src/app/_nav.ts